import { render } from "./ChatContent.vue?vue&type=template&id=be4d0ec8"
import script from "./ChatContent.vue?vue&type=script&lang=js"
export * from "./ChatContent.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__